import {useEffect} from "react";
import {useLocation} from "react-router-dom";
import {useDispatch,useSelector} from "react-redux";
import {setComponentActive} from "../reducers/userConfigSlice";
const sections=new Set(["help","dashboard","clients","salesChannel","orders","products","categories","attributes","catalogs","discounts","configuration","asistente"]);

export const useNavigationSync=()=>{
 const {pathname}=useLocation();
 const dispatch=useDispatch();
 const {logged,componentActive}=useSelector(state=>state.aplicationConfig.userConfig);
 const section=pathname.split("/").filter(Boolean)[0];
 useEffect(()=>{
  if(logged&&sections.has(section)&&componentActive!==section)dispatch(setComponentActive(section));
 },[logged,componentActive,section,dispatch]);
};
